    const stickyATCFindAncestor = function(el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
        return el;
    }

    var stickyWidth;
    let mobileStickyAtc;
    let currentStyle;

    var hypePage = document.querySelectorAll('body.template-page-hype-erg').length > 0;

    const getTextWidth = function(text, font) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        const devicePixelRatio = window.devicePixelRatio || 1;
        canvas.width *= devicePixelRatio;
        canvas.height *= devicePixelRatio;
        context.scale(devicePixelRatio, devicePixelRatio);
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const stickyATCSettings = {
        "classes": {
            openCloseButton: "swatch-dropdown__open-close-button--PLACEHOLDER",
            slidingOptionSelectorOuterContainer: "swatch-dropdown__sliding-option-selector-outer-container--PLACEHOLDER"
        },
        "selectors": {
            atcFormSelector: "#pnt-add-to-cart-form",
            barLabelSpanSelector: ".swatch-dropdown__bar-label span",
            barLabelTextSelector: ".swatch-dropdown__bar-label-text",
            buttonContainerSelector: ".mobile-sticky-atc__button-container",
            dropdownOtherSelector: ".swatch-dropdown--other",
            dropdownBarOtherAllSelector: ".mobile-sticky-atc:not(.mobile-sticky-atc--two-or-less-options) .swatch-dropdown:not(.swatch-dropdown--hide).swatch-dropdown--other",
            dropdownBarOtherAllMobileSelector: ".mobile-sticky-atc .swatch-dropdown:not(.swatch-dropdown--hide).swatch-dropdown--other",
            dropdownBarOtherSelector: ".swatch-dropdown__bar-element--other",
            freshChatSelector: "#fc_frame",
            headerMainContentSelector: "#shopify-section-header .header .main-content",
            mobileStickyATCSelector: "#mobile-sticky-atc",
            nonHiddenDropdownSelector: ".swatch-dropdown:not(.swatch-dropdown--hide)",
            openCloseButtonSelector: ".swatch-dropdown__open-close-button",
            openCloseButtonContainerSelector: ".swatch-dropdown__open-close-button-container",
            optionsContainerSelector: ".mobile-sticky-atc__options-container",
            otherOptionSelectorsSelector: ".swatch-dropdown__sliding-option-selector-outer-container--other",
            otherOptionSelectorLabels: ".swatch-dropdown__sliding-option-selector-label",
            slidingOptionSelectorOuterContainerSelector: ".swatch-dropdown__sliding-option-selector-outer-container",
            singleOptionSelectorSelector: ".single-option-selector",
            specificOpenCloseButtonNotSelector: `#mobile-sticky-atc .swatch-dropdown__open-close-button:not([data-option-index="PLACEHOLDER"])`,
            specificOpenCloseButtonSelector: '#mobile-sticky-atc .swatch-dropdown__open-close-button[data-option-index="PLACEHOLDER"]',
            specificOptionNotSelector: '#mobile-sticky-atc .swatch-dropdown__sliding-option-selector-outer-container:not([data-option-index="PLACEHOLDER"])',
            swatchDropdownSelector: ".swatch-dropdown" ,
            swatchDropdownSlidingOptionSelectorElementSelector:".swatch-dropdown__sliding-option-selector-element"
        },
        "specs": {
            labelTextDescription: "bold 10px Quicksand",
            lessThanThreeLabelTextDescription: "bold 13px Quicksand",
            buttonTextDescription: "bold 10px Quicksand",
            breakPointPx: 1168
        },
        "strings": {
            addToCart: "ADD TO CART",
            chatWithSales: "CHAT WITH SALES"
        }
    }

    const toggleButton = function(e, type, buttonIndex){
        let doNotToggle = false;

        if(e && e.target.matches(".swatch-dropdown__sliding-option-selector-element.option-not-available") || e && e.target.closest('.swatch-dropdown__sliding-option-selector-element.option-not-available')){
            doNotToggle = true;  
        } else if(e && e.target.matches(".swatch-dropdown__sliding-option-selector-element.soldout") || e && e.target.closest('.swatch-dropdown__sliding-option-selector-element.soldout')){
            doNotToggle = true;  
        }

        if(!doNotToggle) {
                let targetButton = type == 'click_outside' ?  document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', '0')}`)[0] : document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', `${buttonIndex}`)}`)[0];
                let value = type == 'click_outside' ? 'open' : targetButton.getAttribute('data-value');
                let index = targetButton.getAttribute('data-option-index');
                let buttons = document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', `${index}`)}`);
                let allOtherButtons = document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonNotSelector.replace('PLACEHOLDER', `${index}`)}`);
                let allOtherOptionSelectors = document.querySelectorAll(`${stickyATCSettings.selectors.specificOptionNotSelector.replace('PLACEHOLDER', `${index}`)}`);
                let newValue = value == 'closed' ? 'open' : 'closed';


            buttons.forEach((button) => {
                if(allOtherButtons.length > 0) {
                    allOtherButtons.forEach((singleButton) => {
                        singleButton.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'open')}`);
                        singleButton.classList.add(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'closed')}`);
                        singleButton.setAttribute('data-value', 'closed');
                        singleButton.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', 'closed');
                    })
                }

                button.style.pointerEvents = "none";
                button.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'open')}`);
                button.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'closed')}`);
                button.setAttribute('data-value', newValue);
                button.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', newValue);
                button.classList.add(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', newValue)}`);

                setTimeout(function () {
                    button.style.pointerEvents = "";
                }, 250);

                const optionSelector = stickyATCFindAncestor(button, `${stickyATCSettings.selectors.swatchDropdownSelector}`).querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`);
                
                if(optionSelector){
                    allOtherOptionSelectors.forEach((singleOptionSelector) => {
                        singleOptionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "open")}`);
                        singleOptionSelector.classList.add(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "closed")}`);
                        singleOptionSelector.setAttribute('data-value', 'closed');
                        singleOptionSelector.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).setAttribute('aria-expanded', false);
                    })
        
                    optionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "open")}`);
                    optionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "closed")}`);

                    let freshChat = document.querySelector('#fc_frame');
                    var harkBadge = document.querySelector("#hark-floating-icon-button-hark");
                    var attentiveCreative = document.querySelector("#attentive_creative");


                    if(freshChat){
                        freshChat.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    if(harkBadge){
                        harkBadge.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    if(attentiveCreative){
                        attentiveCreative.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    let html = document.querySelector('body').closest('html');

                    if(html.getAttribute('data-menu-open') != "true"){
                        if(newValue == 'open'){
                            html.style.overflow = `hidden` 
                        } else {
                            html.style.overflow = `` 
                        }
                    }

                    optionSelector.setAttribute('data-value', newValue);
                    optionSelector.classList.add(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", newValue)}`);
                    optionSelector.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).setAttribute('aria-expanded', `${newValue == 'open' ? true : false }`)
                }
            })
        }
    }

    const dropdownStyling = function(dropdowns, type){
        dropdowns.forEach((dropdown) => {
            let amount = dropdowns.length;
            let swatchWidth;
            let dropdownMaxWidth;
            let swatchLabelText = dropdown.querySelector(`${stickyATCSettings.selectors.barLabelTextSelector}`).innerHTML.toUpperCase();

            if(dropdown.classList.contains(`${stickyATCSettings.selectors.dropdownOtherSelector.replace(".", "")}`)){
                let labels = dropdown.querySelectorAll(`${stickyATCSettings.selectors.barLabelSpanSelector}`);
                let labelArray = [];
                let maxLabelWidth = 0;

                if(labels.length > 0){
                    labels.forEach((label) => {
                        labelArray.push(label.innerHTML);
                    });

                    labelArray.forEach((labelText) => {
                        let width = Math.ceil(1.02 * Math.ceil(getTextWidth(`${labelText}`, `${stickyATCSettings.specs.labelTextDescription}`))) + 1;
                        if(width > maxLabelWidth){
                            maxLabelWidth = width;
                        }
                    })
                }

                swatchWidth = maxLabelWidth + 20 + 22;
                dropdownMaxWidth = swatchWidth + 30;
            } else {
                dropdownMaxWidth = 80;
            }
            if(amount < 3){
                let dropdownLabelwidth = Math.ceil(getTextWidth(`${swatchLabelText}`, `${stickyATCSettings.specs.labelTextDescription}`));

                dropdownMaxWidth = dropdownMaxWidth + dropdownLabelwidth + 14;
            }
            dropdown.style.maxWidth = type == "mobile" ? `${dropdownMaxWidth}px` : ``;
        });
    }


    const initOpenCloseButtons = function(openCloseButtons){
        // let buttonContainer = document.querySelector(`${stickyATCSettings.selectors.buttonContainerSelector}`);
        // let maxButtonWidth = (1.03 * Math.ceil(getTextWidth(`${stickyATCSettings.strings.addToCart}`, `${stickyATCSettings.specs.buttonTextDescription}`))) + 24 + 1;

        // buttonContainer.style.maxWidth = `${maxButtonWidth}px`;

        openCloseButtons.forEach((button) => {
            button.closest('.swatch-dropdown').addEventListener('click', function(e){
                if(window.innerWidth < 1168){
                    toggleButton(e, 'click', button.getAttribute('data-option-index'))
                } else {
                    toggleButton(e, 'click_outside')
                }
            }
        );
        })
    }

    const stickyAddToCart = function(event, atcForm){
        event.preventDefault();
        if(validateAddCart(atcForm)) {
            addToCart(atcForm);
        }
        return false;
    }

    const stickyATCThrottle = function(func) {
        var timer;
        return function(event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 500, event);
        };
    };

    const calculateOptionLabelWidth = function(otherOptionSelectorLabels, type){
            let widths = [];
            otherOptionSelectorLabels.forEach((otherOptionSelectorLabels) => {
                widths.push(otherOptionSelectorLabels.offsetWidth); 
            });
            let longestWidth = widths.sort((a, b) => (a > b ? -1 : 1))[0]
            otherOptionSelectorLabels.forEach((otherOptionSelectorLabel) => {
                if(type == "mobile"){
                    otherOptionSelectorLabel.style.width = `${longestWidth}px`;
                } else {
                    otherOptionSelectorLabel.style.removeProperty('width');
                }
            });
    }

    const barHeightMobileUpdate = function(contentHeight, element, element2, selectorOuterContainers, height, headerHeight){
        
        if(contentHeight && contentHeight > 77 && element){
            element.style.height = `${contentHeight}px`;
            element2.style.minHeight = `${contentHeight}px`;
 
        } else if(contentHeight && contentHeight <= 77 && element){
            element.style.height = ``;
            element2.style.minHeight = ``;
        }

        selectorOuterContainers.forEach((selectorOuterContainer) => {
            selectorOuterContainer.style.maxHeight = `${height - contentHeight - headerHeight}px`
        })

        element.style.removeProperty('transform');
    }

    const barHeightDesktopUpdate = function(element, selectorOuterContainers){
        element.style.removeProperty("height");
            element.style.removeProperty("minHeight");
            setTimeout(function(){
                let elementOffsetHeight = element.offsetHeight;
                // if(hypePage == true){
                //     elementOffsetHeight = 0 - element.offsetHeight;
                // }
                element.style.transform = `translateY(${elementOffsetHeight}px)`;
            }, 100)

            selectorOuterContainers.forEach((selectorOuterContainer) => {
                selectorOuterContainer.style.removeProperty('maxHeight');
            })
    }


    const updateBarHeight = function(type, switchBetweenScreenWidths){
        let contentHeight = [document.querySelector(`${stickyATCSettings.selectors.optionsContainerSelector}`).offsetHeight, document.querySelector(`${stickyATCSettings.selectors.buttonContainerSelector}:not(.hide)`).offsetHeight].sort((a, b) => (a > b ? -1 : 1))[0]
        let element = document.querySelector(`${stickyATCSettings.selectors.mobileStickyATCSelector}`);
        let element2 = document.querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`);
        let selectorOuterContainers = document.querySelectorAll(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`)
        let height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
        let headerHeight = document.querySelector(`${stickyATCSettings.selectors.headerMainContentSelector}`) ? document.querySelector(`${stickyATCSettings.selectors.headerMainContentSelector}`).offsetHeight : 0;
        
        if(type == "mobile"){
            element.setAttribute('data-verified-desktop', false);
            if(switchBetweenScreenWidths == "desktop_to_mobile"){
                let elementOffsetHeight = element.offsetHeight;
                if(hypePage == true){
                    elementOffsetHeight = 0 - element.offsetHeight;
                }
                element.style.transform = `translateY(-${elementOffsetHeight}px)`;
                setTimeout(function(){
                    element.style.transform = `translateY(0px)`;
                    barHeightMobileUpdate(contentHeight, element, element2, selectorOuterContainers, height, headerHeight);
                    element.setAttribute('data-verified-mobile', true);
                },
                250)
            } else {
                element.style.transform = `translateY(0px)`;
                barHeightMobileUpdate(contentHeight, element, element2, selectorOuterContainers, height, headerHeight);
                element.setAttribute('data-verified-mobile', true);
            }
        }

        else if(type == "desktop"){
            element.setAttribute('data-verified-mobile', false);
            let elementOffsetHeight = element.offsetHeight;
            // if(hypePage == true){
            //     elementOffsetHeight = 0 - element.offsetHeight;
            // }
            if(switchBetweenScreenWidths == "mobile_to_desktop"){
                element.style.transform = `translateY(0px)`;
                setTimeout(function(){
                    element.style.transform = `translateY(${elementOffsetHeight}px)`;
                    barHeightDesktopUpdate(element, selectorOuterContainers);
                    element.setAttribute('data-verified-desktop', true);
                },
                250)
            } else {
                element.style.transform = `translateY(${elementOffsetHeight}px)`;
                barHeightDesktopUpdate(element, selectorOuterContainers);
                element.setAttribute('data-verified-desktop', true);
            }
        }

    }

    const adjustOtherLabelPosition = function(type){
        let dropdownBarOtherAll = window.innerWidth > 380 ? document.querySelectorAll(`${stickyATCSettings.selectors.dropdownBarOtherAllSelector}`) : document.querySelectorAll(`${stickyATCSettings.selectors.dropdownBarOtherAllMobileSelector}`);
        let dropdownBarOtherAllOptions = document.querySelectorAll(`${stickyATCSettings.selectors.dropdownBarOtherAllMobileSelector}`);
        
        if(dropdownBarOtherAllOptions.length > 0){
            dropdownBarOtherAllOptions.forEach((dropdownBarOtherOptions) => {
                let label = dropdownBarOtherOptions.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).querySelector(`${stickyATCSettings.selectors.barLabelTextSelector}`);
                if(label){
                    label.style.minWidth = ``;
                };
            })
        }
        
        if(dropdownBarOtherAll.length > 0){
            dropdownBarOtherAll.forEach((dropdownBarOther) => {
                let width = dropdownBarOther.querySelector(`${stickyATCSettings.selectors.dropdownBarOtherSelector}`).offsetWidth;
                let label = dropdownBarOther.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).querySelector(`${stickyATCSettings.selectors.barLabelTextSelector}`);
                if(label){
                    label.style.minWidth = type == "mobile" ? `${width}px` : ``;
                };
            })
        }
    }

    const adjustOtherOptionSelectorWidth = function(type){
        let otherOptionSelectors = document.querySelectorAll(`${stickyATCSettings.selectors.otherOptionSelectorsSelector}`);
        
        if(otherOptionSelectors.length > 0){
            otherOptionSelectors.forEach((otherOptionSelector) => {
                let otherOptionSelectorLabels = otherOptionSelector.querySelectorAll(`${stickyATCSettings.selectors.otherOptionSelectorLabels}`);
                if(otherOptionSelectorLabels.length > 0){
                    let itemsProcessed = 0;
                    otherOptionSelectorLabels.forEach((otherOptionSelectorLabel) => {
                        otherOptionSelectorLabel.style.minWidth = ``;
                        itemsProcessed++;
                        if(itemsProcessed === otherOptionSelectorLabels.length) {
                            calculateOptionLabelWidth(otherOptionSelectorLabels, type);
                          }
                    })
                }
            });
        }
    }

    const updateBarStyling = function(init){
        let type = window.innerWidth >= 1168 ? 'desktop' : 'mobile';
        
        let switchBetweenScreenWidths = false;

        if(currentStyle != type){
            if(currentStyle == "mobile"){
                switchBetweenScreenWidths = "mobile_to_desktop"
            } else {
                switchBetweenScreenWidths = "desktop_to_mobile"
            }
            currentStyle = type;
        }

        if(init == true){
            currentStyle = type;
        }

        if (window.innerWidth != stickyWidth || init == true) {
            stickyWidth = window.innerWidth;

            updateBarHeight(type, switchBetweenScreenWidths);
            adjustOtherLabelPosition(type);
            adjustOtherOptionSelectorWidth(type);
            let dropdowns = mobileStickyAtc.querySelectorAll(`${stickyATCSettings.selectors.nonHiddenDropdownSelector}`);

            if(dropdowns) {
                dropdownStyling(dropdowns, type);
            }
            initATCButton(type);

        }
    }

    const initATCButton = function(type){
        let atcButtonContainers = document.querySelectorAll(`${stickyATCSettings.selectors.buttonContainerSelector}`);
        let strings = [`${stickyATCSettings.strings.addToCart}`, `${stickyATCSettings.strings.chatWithSales}`]
        atcButtonContainers.forEach((atcButtonContainer, index) => {
            let maxButtonWidth = (1.35 * Math.ceil(getTextWidth(strings[index], `${stickyATCSettings.specs.buttonTextDescription}`))) + 24 + 1;
            atcButtonContainer.style.maxWidth = type == "mobile" ? `${maxButtonWidth}px` : ``;
        })

        let atcForm = $(`${stickyATCSettings.selectors.atcFormSelector}`);
        let atcButton = document.querySelector(`${stickyATCSettings.selectors.buttonContainerSelector} button`);
        
        if(atcForm && atcButton){
            atcButton.onclick = function(e){
                stickyAddToCart(e, atcForm);
                toggleButton(e, 'click_outside')
            }
        }
    }

    const initVariantSelectors = function(mobileStickyAtc){
        
        let variantSelectors = mobileStickyAtc.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSlidingOptionSelectorElementSelector}`);
        if(variantSelectors.length > 0){
            variantSelectors.forEach((variantSelector) => {
                variantSelector.onclick = function(e){
                    if(!variantSelector.classList.contains('option-not-available') && !variantSelector.classList.contains('soldout')){
                        let input = variantSelector.querySelector('input[type="radio"]');
                        input.dispatchEvent(new Event('change'));
                        let mainProductInput = document.querySelector(`.options .swatch[data-option-name="${variantSelector.getAttribute('data-key')}"] .variants-wrap input[type="radio"][value="${variantSelector.getAttribute('data-value')}"]`);
                        if(mainProductInput){
                            mainProductInput.dispatchEvent(new Event('change'));
                        }
                    }
                    if(hypePage == true && window.innerWidth < 1168 ){
                        setTimeout(function() {
                            toggleButton(null, 'click_outside');
                        }, 500)
                    }
                }
            })
        }
    }

    const initStickyATC = function(){
        stickyWidth = window.innerWidth

        mobileStickyAtc = document.querySelector(`${stickyATCSettings.selectors.mobileStickyATCSelector}`);
        let openCloseButtons = mobileStickyAtc.querySelectorAll(`${stickyATCSettings.selectors.openCloseButtonSelector}`);
        

        if(openCloseButtons){
            initOpenCloseButtons(openCloseButtons);
        };

        initVariantSelectors(mobileStickyAtc);

        let atcFormInput = document.querySelector('form[action="/cart/add"].add-to-cart-form');

        window.addEventListener('click', function(e){
            if (!mobileStickyAtc.contains(e.target)){
                toggleButton(e, 'click_outside');
          } 
        });

        window.addEventListener("DOMContentLoaded", (event) => {
            updateBarStyling(true)
        });

        window.addEventListener("resize", stickyATCThrottle(() => updateBarStyling()));
    }

    initStickyATC();
